import { render, staticRenderFns } from "./FilesSearchView.vue?vue&type=template&id=0a00ed4c&"
import script from "./FilesSearchView.vue?vue&type=script&lang=ts&"
export * from "./FilesSearchView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports